/**
 * Disclaimer: modules in _shims aren't intended to be imported by SDK users.
 */
export function isFsReadStream(value) {
  return false;
}
//# sourceMappingURL=node-readable.mjs.map
